module.exports = __webpack_public_path__ + "img/dotted_background.099c5cbc.png";